import React, { useState } from "react";
import { Outlet } from "react-router-dom";

const DetectionContext = React.createContext(null);

export const useDetectionContext = () => {
    return React.useContext(DetectionContext);
};

function DetectionDataProvider() {
    const [showDetectionConfigPopup, setShowDetectionConfigPopup] = useState(false);
    const [detectionConfig, setDetectionConfig] = useState({
        projectid: '',
        projectname: '',
        vesselid: '',
        vesselname: '',
        deviceid: '',
        devicename: ''
    });

    const [selectedClusterDateRange, setSelectedClusterDateRange] = useState([null, null]);

    const [chartHasAudioData, setChartHasAudioData] = useState(false);
    const [detection, setDetection] = useState('');
    const [detectionIndex, setDetectionIndex] = useState(0);
    const [detectionCount, setDetectionCount] = useState(0);
    const [detectionLoading, setDetectionLoading] = useState(false);
    const [detectionStartDate, setDetectionStartDate] = useState('');
    const [detectionEndDate, setDetectionEndDate] = useState('');
    const [selectedDetectionDateRange, setSelectedDetectionDateRange] = useState([null, null]);
    const [currentValidationStatus, setCurrentValidationStatus] = useState('');
    const [selectedFilter, setSelectedFilter] = useState('All');
    const [clusterLink, setClusterLink] = useState({
        linkId: -1,
        linkType: null,
        clusterStart: null,
        clusterEnd: null,
        clusterId: -1
    });
    const [saveValidationClicked, setSaveValidationClicked] = useState(false);
    const [selectedOption, setSelectedOption] = useState('CET-D1');
    const [refreshChart, setRefreshChart] = useState(false);
    const [refreshDetection, setRefreshDetection] = useState(false);
    const [refreshFlag, setRefreshFlag] = useState(true);

    return (
        <DetectionContext.Provider
            value={{
                ShowDetectionConfigPopup: showDetectionConfigPopup,
                DetectionConfig: detectionConfig,
                SetDetectionConfig: setDetectionConfig,
                SetShowDetectionConfigPopup: setShowDetectionConfigPopup,

                SelectedClusterDateRange: selectedClusterDateRange,
                SetSelectedClusterDateRange: setSelectedClusterDateRange,

                ChartHasAudioData: chartHasAudioData,
                SetChartHasAudioData: setChartHasAudioData,
                Detection: detection,
                SetDetection: setDetection,
                DetectionIndex: detectionIndex,
                SetDetectionIndex: setDetectionIndex,
                DetectionCount: detectionCount,
                SetDetectionCount: setDetectionCount,
                DetectionLoading: detectionLoading,
                SetDetectionLoading: setDetectionLoading,
                DetectionStartDate: detectionStartDate,
                SetDetectionStartDate: setDetectionStartDate,
                DetectionEndDate: detectionEndDate,
                SetDetectionEndDate: setDetectionEndDate,
                SelectedDetectionDateRange: selectedDetectionDateRange,
                SetSelectedDetectionDateRange: setSelectedDetectionDateRange,
                CurrentValidationStatus: currentValidationStatus,
                SetCurrentValidationStatus: setCurrentValidationStatus,
                SelectedFilter: selectedFilter,
                SetSelectedFilter: setSelectedFilter,
                ClusterLink: clusterLink,
                SetClusterLink: setClusterLink,
                SaveValidationClicked: saveValidationClicked,
                SetSaveValidationClicked: setSaveValidationClicked,
                SelectedOption: selectedOption,
                SetSelectedOption: setSelectedOption,

                RefreshChart: refreshChart,
                SetRefreshChart: setRefreshChart,
                RefreshFlag: refreshFlag,
                SetRefreshFlag: setRefreshFlag,
                RefreshDetection: refreshDetection,
                SetRefreshDetection: setRefreshDetection
            }}>
            <Outlet />
        </DetectionContext.Provider>
    );
}

export default DetectionDataProvider;